/* Maketek PDP: gallery thumbnail switcher, quantity stepper, and
   related-products recommendations fetch. Vanilla JS, no dependencies. */

(function () {
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('.qty-stepper__input');
    var decreaseBtn = stepper.querySelector('[data-qty-decrease]');
    var increaseBtn = stepper.querySelector('[data-qty-increase]');
    if (!input) return;

    function setValue(next) {
      var min = parseInt(input.min, 10) || 1;
      if (next < min) next = min;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function () {
        setValue((parseInt(input.value, 10) || 1) - 1);
      });
    }
    if (increaseBtn) {
      increaseBtn.addEventListener('click', function () {
        setValue((parseInt(input.value, 10) || 1) + 1);
      });
    }
  });
})();

(function () {
  var gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  var mainImage = gallery.querySelector('#ProductMainImage');
  var mediaScript = gallery.querySelector('[data-gallery-media]');
  if (!mainImage || !mediaScript) return;

  var mediaData = [];
  try {
    mediaData = JSON.parse(mediaScript.textContent) || [];
  } catch (e) {
    mediaData = [];
  }
  if (!mediaData.length) return;

  var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
  var activeIndex = 0;

  function setActiveThumb(index) {
    thumbs.forEach(function (t) {
      var active = parseInt(t.dataset.index, 10) === index;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function showMain(index) {
    var item = mediaData[index];
    if (!item) return;
    activeIndex = index;
    mainImage.src = item.full;
    if (item.srcset) mainImage.srcset = item.srcset;
    mainImage.alt = item.alt || '';
    setActiveThumb(index);
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showMain(parseInt(thumb.dataset.index, 10));
    });
  });

  /* Lightbox: click-to-zoom-in trigger over the main image, native <dialog>
     with prev/next + thumb strip, click-to-toggle 2x zoom + pointer-drag pan. */
  var zoomTrigger = gallery.querySelector('[data-gallery-zoom]');
  var dialog = document.querySelector('[data-product-lightbox]');
  if (!zoomTrigger || !dialog) return;

  var stageImage = dialog.querySelector('[data-lightbox-image]');
  var prevBtn = dialog.querySelector('[data-lightbox-prev]');
  var nextBtn = dialog.querySelector('[data-lightbox-next]');
  var closeBtn = dialog.querySelector('[data-lightbox-close]');
  var thumbStrip = dialog.querySelector('[data-lightbox-thumbs]');
  if (!stageImage) return;

  var lightboxIndex = 0;
  var multiImage = mediaData.length > 1;
  var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Modal sahne durumu: pinch/pan/çift dokunuş */
  var scale = 1;
  var panX = 0;
  var panY = 0;
  var pointers = new Map();
  var pinchStartDist = 0;
  var pinchStartScale = 1;
  var dragStartX = 0;
  var dragStartY = 0;
  var lastTapAt = 0;
  var swipeStartX = null;
  var MAX_SCALE = 4;

  function applyTransform(animate) {
    stageImage.style.transition = animate && !reducedMotion ? 'transform 0.18s ease-out' : 'none';
    stageImage.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + scale + ')';
    stageImage.classList.toggle('is-zoomed', scale > 1);
  }

  if (prevBtn) prevBtn.hidden = !multiImage;
  if (nextBtn) nextBtn.hidden = !multiImage;
  if (thumbStrip) {
    thumbStrip.hidden = !multiImage;
    mediaData.forEach(function (item, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-lightbox__thumb';
      btn.dataset.lightboxThumbIndex = String(i);
      btn.setAttribute('aria-label', 'Ürün görseli ' + (i + 1));
      var img = document.createElement('img');
      img.src = item.thumb;
      img.alt = '';
      img.loading = 'lazy';
      btn.appendChild(img);
      btn.addEventListener('click', function () {
        showLightbox(i);
      });
      thumbStrip.appendChild(btn);
    });
  }

  function resetZoom() {
    scale = 1;
    panX = 0;
    panY = 0;
    pointers.clear();
    applyTransform(false);
  }

  function preload(index) {
    var item = mediaData[index];
    if (!item) return;
    var img = new Image();
    img.src = item.full;
  }

  function showLightbox(index) {
    if (index < 0) index = mediaData.length - 1;
    if (index >= mediaData.length) index = 0;
    lightboxIndex = index;
    var item = mediaData[index];
    stageImage.src = item.full;
    if (item.srcset) stageImage.srcset = item.srcset;
    stageImage.alt = item.alt || '';
    resetZoom();

    if (thumbStrip) {
      Array.prototype.forEach.call(thumbStrip.querySelectorAll('[data-lightbox-thumb-index]'), function (t) {
        t.classList.toggle('is-active', parseInt(t.dataset.lightboxThumbIndex, 10) === index);
      });
    }

    preload(index + 1 < mediaData.length ? index + 1 : 0);
    preload(index - 1 >= 0 ? index - 1 : mediaData.length - 1);
  }

  /* Masaüstü: imleci takip eden içeriden zoom (büyüteç modeli) */
  if (hoverCapable) {
    zoomTrigger.classList.add('has-hover-zoom');
    var HOVER_SCALE = 2.2;
    zoomTrigger.addEventListener('mousemove', function (e) {
      var r = zoomTrigger.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      mainImage.style.transformOrigin = x + '% ' + y + '%';
      mainImage.style.transform = 'scale(' + HOVER_SCALE + ')';
    });
    zoomTrigger.addEventListener('mouseleave', function () {
      mainImage.style.transform = '';
      mainImage.style.transformOrigin = '';
    });
  }

  function openLightbox() {
    showLightbox(activeIndex);
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  zoomTrigger.addEventListener('click', function (e) {
    // Masaüstünde hover zoom esas; modal yalnızca klavye aktivasyonuyla açılır
    // (erişilebilirlik). Dokunmatik cihazlarda tek dokunuş modal açar.
    if (hoverCapable && e.detail !== 0) return;
    openLightbox();
  });

  if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
  if (prevBtn) prevBtn.addEventListener('click', function () { showLightbox(lightboxIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showLightbox(lightboxIndex + 1); });

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) dialog.close();
  });

  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') showLightbox(lightboxIndex - 1);
    else if (e.key === 'ArrowRight') showLightbox(lightboxIndex + 1);
  });

  dialog.addEventListener('close', function () {
    resetZoom();
    showMain(lightboxIndex);
  });

  /* Modal sahnesi: pinch-zoom, pan, çift dokunuş, zoom yokken yatay kaydırma
     ile önceki/sonraki görsel. Pointer Events tabanlı — mouse ve dokunmatikte
     aynı kod yolu. */
  function pinchDistance() {
    var pts = Array.from(pointers.values());
    return Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
  }

  stageImage.addEventListener('pointerdown', function (e) {
    e.preventDefault();
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    stageImage.setPointerCapture(e.pointerId);

    if (pointers.size === 2) {
      pinchStartDist = pinchDistance();
      pinchStartScale = scale;
      swipeStartX = null;
    } else if (pointers.size === 1) {
      dragStartX = e.clientX - panX;
      dragStartY = e.clientY - panY;
      if (scale === 1) swipeStartX = e.clientX;
    }
  });

  stageImage.addEventListener('pointermove', function (e) {
    if (!pointers.has(e.pointerId)) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

    if (pointers.size === 2) {
      // Pinch: iki parmak arası mesafe oranıyla ölçekle
      var next = pinchStartScale * (pinchDistance() / pinchStartDist);
      scale = Math.min(MAX_SCALE, Math.max(1, next));
      if (scale === 1) { panX = 0; panY = 0; }
      applyTransform(false);
    } else if (pointers.size === 1 && scale > 1) {
      panX = e.clientX - dragStartX;
      panY = e.clientY - dragStartY;
      applyTransform(false);
    }
  });

  ['pointerup', 'pointercancel'].forEach(function (evt) {
    stageImage.addEventListener(evt, function (e) {
      var wasPinch = pointers.size === 2;
      pointers.delete(e.pointerId);

      if (wasPinch || pointers.size > 0) return;

      // Zoom yokken hızlı yatay kaydırma: görsel değiştir
      if (scale === 1 && swipeStartX !== null && multiImage) {
        var dx = e.clientX - swipeStartX;
        if (Math.abs(dx) > 50) {
          showLightbox(dx > 0 ? lightboxIndex - 1 : lightboxIndex + 1);
          swipeStartX = null;
          return;
        }
      }
      swipeStartX = null;

      // Çift dokunuş: dokunulan noktaya 2.5x zoom / sıfırla
      var now = Date.now();
      if (now - lastTapAt < 320) {
        lastTapAt = 0;
        if (scale > 1) {
          scale = 1;
          panX = 0;
          panY = 0;
        } else {
          scale = 2.5;
          var r = stageImage.getBoundingClientRect();
          // Dokunulan nokta merkezde kalsın
          panX = (r.left + r.width / 2 - e.clientX) * (scale - 1);
          panY = (r.top + r.height / 2 - e.clientY) * (scale - 1);
        }
        applyTransform(true);
      } else {
        lastTapAt = now;
      }
    });
  });
})();

(function () {
  document.querySelectorAll('[data-recommendations-url]').forEach(function (el) {
    fetch(el.getAttribute('data-recommendations-url'))
      .then(function (response) {
        return response.ok ? response.text() : null;
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var replacement = doc.getElementById(el.id);
        if (replacement && replacement.innerHTML.trim() !== '') {
          el.replaceWith(replacement);
        }
      })
      .catch(function () {
        /* Keep the server-rendered fallback content on failure. */
      });
  });
})();

/* Açıklama düzenleyici: eski siteden aktarılan açıklamalar <div> satırlarından
   oluşuyor. "Etiket: değer" satırlarını okunur bir özellik listesine, kısa
   başlık satırlarını ara başlığa çevirir; boş satırları ve başlığı tekrar eden
   ilk satırı kaldırır. Eşleşmeyen içerik olduğu gibi kalır. */
(function () {
  var root = document.querySelector('[data-product-description]');
  if (!root) return;

  var title = (root.getAttribute('data-product-title') || '').trim().toLowerCase();
  var pairPattern = /^([^:]{2,60}):\s*(.+)$/;
  var children = Array.prototype.slice.call(root.children);
  var currentList = null;
  var seenSpecs = false;

  function textOf(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function isHeadingLike(text) {
    return text.length > 1 && text.length <= 40 && !/[.:;,!?]$/.test(text) && text.indexOf(':') === -1;
  }

  children.forEach(function (el, index) {
    if (el.tagName !== 'DIV' && el.tagName !== 'P') {
      currentList = null;
      return;
    }

    var text = textOf(el);

    if (!text && !el.querySelector('img, iframe, table')) {
      el.remove();
      return;
    }

    if (index < 3 && title && text.toLowerCase() === title) {
      el.remove();
      return;
    }

    var match = text.match(pairPattern);
    if (match && !el.querySelector('a, img, table')) {
      if (!currentList) {
        currentList = document.createElement('dl');
        currentList.className = 'spec-list';
        el.before(currentList);
      }
      var row = document.createElement('div');
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = match[1].trim();
      dd.textContent = match[2].trim();
      row.append(dt, dd);
      currentList.append(row);
      el.remove();
      seenSpecs = true;
      return;
    }

    currentList = null;

    var next = el.nextElementSibling;
    var nextText = next ? textOf(next) : '';
    var leadsIntoList = next && (next.tagName === 'UL' || next.tagName === 'OL' || pairPattern.test(nextText) || (!nextText && next.nextElementSibling));
    if (isHeadingLike(text) && (leadsIntoList || seenSpecs || /teknik|özellik|bilgi/i.test(text))) {
      var heading = document.createElement('h3');
      heading.textContent = text;
      el.replaceWith(heading);
    }
  });

  root.classList.add('is-enhanced');
})();

/* Mobil sabit satın alma çubuğu: ana "Sepete Ekle" butonu ekranın üstünden
   çıkınca görünür, butona geri dönülünce gizlenir. */
(function () {
  var bar = document.querySelector('[data-pdp-sticky]');
  var form = document.getElementById('ProductForm');
  var target = form && form.querySelector('[type="submit"]');
  if (!bar || !target || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    var entry = entries[0];
    var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    bar.querySelector('button').tabIndex = show ? 0 : -1;
    document.body.classList.toggle('has-pdp-sticky', show);
  }).observe(target);
})();
